import { Place } from '@/types/google-maps.types';

export function formatGoogleGeocoderToPlace(placeToFormat: google.maps.GeocoderResult[]): Place {
  let geolocated = placeToFormat.find(
    (result) => result.types.includes('street_address') || result.types.includes('address_components'),
  );

  if (!geolocated) {
    geolocated
      = placeToFormat.find((result) => result.types.includes('administrative_area_level_2')) || placeToFormat[0];
  }

  const city = geolocated?.address_components?.find(
    (addressComponent) => addressComponent.types.includes('administrative_area_level_2') && addressComponent.types.includes('political'),
  );

  const state = geolocated?.address_components?.find(
    (addressComponent) => addressComponent.types.includes('administrative_area_level_1') && addressComponent.types.includes('political'),
  );

  const street = geolocated?.address_components?.find((addressComponent) => addressComponent.types.includes('route'));

  const formattedPlace: Place = {
    formattedAddress: geolocated.formatted_address,
    latitude: geolocated.geometry.location.lat(),
    longitude: geolocated.geometry.location.lng(),
    types: geolocated.types,
    street: street?.long_name ?? '',
    city: city?.long_name ?? '',
    state: state?.short_name ?? '',
    placeId: geolocated.place_id,
    locationType: geolocated.geometry.location_type,
  };

  return formattedPlace;
}
